// import Vue from 'vue';
import {
  LOGOUT,
  CHECK_AUTHENTICATION,
  LOGIN,
  SELECT_CUSTOMER,
} from './../../mutation-types';

export default {
  [CHECK_AUTHENTICATION](state) {
    let unixEpoch = new Date() / 1000;
    if (!!localStorage.getItem('jwt') && localStorage.getItem('jwt_expires') && localStorage.getItem('jwt_expires') < unixEpoch) {
      state.authenticated = true;
    } else {
      state.managed_sps = [];
      state.authenticated = false;
    }
    unixEpoch = 0;
  },

  [LOGIN](state, authObj) {
    state.authenticated = true;
    state.managed_sps = authObj.managed_sps;
    state.user = authObj.user;
    localStorage.setItem('jwt', authObj.jwt);
    localStorage.setItem('jwt_expiry', authObj.expires);

    const customerID = localStorage.getItem('selected_sp_id');
    if (customerID) {
      let i = 0;
      for (i = 0; i < state.managed_sps.length; i += 1) {
        if (state.managed_sps[i].sp_id === customerID) {
          state.selected_sp = state.managed_sps[i];
          localStorage.setItem('selected_sp_id', state.managed_sps[i].sp_id);
          return;
        }
      }
    }
    if (state.managed_sps.length === 1) {
      state.selected_sp = state.managed_sps[0];
      localStorage.setItem('selected_sp_id', state.managed_sps[0].sp_id);
      return;
    }
    state.selected_sp = {};
    localStorage.removeItem('selected_sp_id');
  },

  [LOGOUT](state) {
    state.authenticated = false;
    state.managed_sps = [];
    localStorage.removeItem('jwt');
    localStorage.removeItem('jwt_expiry');
  },

  [SELECT_CUSTOMER](state, customerID) {
    if (customerID) {
      let i = 0;
      for (i = 0; i < state.managed_sps.length; i += 1) {
        if (state.managed_sps[i].sp_id === customerID) {
          state.selected_sp = state.managed_sps[i];
          localStorage.setItem('selected_sp_id', state.managed_sps[i].sp_id);
          return;
        }
      }
    }
    if (state.managed_sps.length === 1) {
      state.selected_sp = state.managed_sps[0];
      localStorage.setItem('selected_sp_id', state.managed_sps[0].sp_id);
      return;
    }
    state.selected_sp = {};
    localStorage.removeItem('selected_sp_id');
  },

};



// WEBPACK FOOTER //
// ./src/app/store/modules/auth/mutations.js